import { render, staticRenderFns } from "./productBeforePromotion.vue?vue&type=template&id=67044b1f"
import script from "./productBeforePromotion.vue?vue&type=script&lang=js"
export * from "./productBeforePromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports